import {
  Space,
  Tabs,
  Typography
} from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as TEACHER_SERVICES from "api/services/teacher/teacher.services";
import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styles from "./style.module.css";

import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import * as appRoutes from "config/routes.config";
import { useNavigate } from "react-router-dom";
import AppScreen from "../ScreenWithSidebar";

//!IMAGES
import Calendar from "../../../assets/images/app/calendar_icon.svg";
import Reservation from "../../../assets/images/app/calendar_teacher_icon.svg";
import AlbertImage from "../../../assets/images/app/levieuxalbert.svg";
//
import { StatusCode, UserRoles } from "common/enums";
import Breadcrumbs from "components/breadcrumbs";
import HelpPopover from "components/help";
import { setIsCheckingBooking, setIsNewData } from "store/app/appSlice";
import AppCalendar from "../Calendar";
import MainTeacherCalendar from "../calendarTeacher";

const { TabPane } = Tabs;

const { Title } = Typography;

const TeacherSetCalendar: FC = () => {
  //!HOOKS
  const auth = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass, isCheckingBooking } = useSelector((state) => state.app);
  //!STATE
  const [teacherData, setTeacherData] = useState<any>();
  const [bookingCount, setBookingCount] = useState<number>(0);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const getTeacherData = async (teacherId: string) => {
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
      setTeacherData(response?.data);
    } catch (error: any) { }
  };

  const [activeTab, setActiveTab] = useState<any>("0");

  const getBookingData = async () => {
    try {
      const response = await TEACHER_SERVICES.getBookingData(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setBookingCount(response?.data?.length);
        }
        else {
          setBookingCount(0);
        }
      }
    } catch (error: any) {
      console.error("Error fetching booking data:", error);
    } finally {
      dispatch(setIsNewData(false));
    }
  };

  useEffect(() => {
    if (user) {
      getTeacherData(user?._id);
      getBookingData();
    }
  }, [user]);

  useEffect(() => {
    if (isCheckingBooking) {
      setActiveTab("1");
      setTimeout(() => {
        dispatch(setIsCheckingBooking(false))
      }, 2000);
    }
  }, [isCheckingBooking]);

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile && auth.user?.roles?.includes(UserRoles.TEACHER) ? (!userHavingCalendar || userTeachingOrganismClass) ? "125px" : "70px" : "0px" }}>
        {!isMobile && <Breadcrumbs isCalendar={true} />}
        {user?.isActive && user?.step === "completed" ?
          <AppScreen className={styles.dashboard}>
            <div className={styles.main}>
              <div className="header-container-teacher">
                <Space align="center" size="middle">
                  <div className="icon-wrapper">
                    <img src={Calendar} height={30} />
                  </div>
                  <Title level={4} style={{ margin: 0 }}>
                    Mes calendriers
                  </Title>
                  <div style={{ marginLeft: "10px", marginTop: "5px" }}>
                    <HelpPopover id={"dashboard_mon_calendrier"} />
                  </div>
                </Space>
              </div>

              <div className="navigation-tabs-container">
                <Tabs
                  tabBarStyle={{ borderRadius: "0px", overflow: "hidden", border: "0px solid transparent !important", backgroundColor: "transparent !important", fontSize: "1em !important" }}
                  activeKey={activeTab}
                  onChange={(key) => setActiveTab(key)}
                  size="large"
                  type="line"
                >
                  <TabPane
                    tab={
                      <span className={activeTab == "0" ? "tabTitleBoxActive" : "tabTitleBox"}>
                        <img src={Calendar} height={30} />
                        Mon calendier
                      </span>
                    }
                    key="0"
                  />
                  <TabPane
                    tab={
                      <>
                        <span className={activeTab == "1" ? "tabTitleBoxActive" : "tabTitleBox"}>
                          <img src={Reservation} height={25} />
                          Mes réservations
                        </span>
                        {bookingCount > 0 && <li style={{ height: 20, width: 20, background: "red", color: "white", borderRadius: "50%", textAlign: "center", position: "absolute", top: "10px", right: "0px", zIndex: "77", display: "flex", alignItems: "center", justifyContent: "center" }}>{bookingCount}</li>}
                      </>
                    }
                    key="1"
                  />
                </Tabs>
                <div className="tab-content">{activeTab === "0" ? <MainTeacherCalendar currentTeacher={teacherData} /> : <AppCalendar />}</div>
              </div>
            </div>
          </AppScreen> :
          <AppScreen className={styles.dashboard}>
            <H1 className={styles.title}>Bienvenue {auth?.user?.firstname}</H1>
            <div className={styles.dashboardUserBox}>
              <img src={AlbertImage} width={240} height={240} style={{ marginTop: "20px", marginBottom: "10px" }}></img>
              <p className={styles.dashboardUserMessage} style={{ fontFamily: "CartoonFont" }}>Oups, tu n’as pas encore accès à cette fonctionnalité!<br />Patience... ton compte est en cours de validation. </p>
              {user?.step !== "completed" && <AppButton onClick={() => navigate(appRoutes.COMPLETE_PROFILE)}>Completer mon profil</AppButton>}
            </div>
          </AppScreen>
        }
      </div>
    </React.Fragment>
  );
};

export default TeacherSetCalendar;
